import type { ReactNode } from 'react';

interface PageTitleProps {
  title: string;
  subtitle?: string;
  /** Botões/links no canto direito (ex: filtros, ações primárias) */
  actions?: ReactNode;
  className?: string;
}

/**
 * Título de página padronizado do design system.
 *
 * @example
 * <PageTitle
 *   title="Processos"
 *   subtitle="Acompanhe e gerencie os processos de aquisição"
 *   actions={<Button variant="primary">Novo processo</Button>}
 * />
 */
export default function PageTitle({ title, subtitle, actions, className }: PageTitleProps) {
  return (
    // Mobile: empilha título e ações (evita esmagar/sobrepor o título em telas
    // estreitas). sm+: volta ao layout lado-a-lado (título à esquerda, ações à direita).
    <div
      className={`mb-6 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4 ${className ?? ''}`}
    >
      <div className="min-w-0 sm:flex-1">
        <h1
          className="m-0 text-[22px] font-bold leading-tight tracking-[-0.015em] text-[var(--fg)] break-words [overflow-wrap:anywhere]"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 mb-0 text-[13.5px] text-[var(--fg-muted)]">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
